//export default class HeroAlternative {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.hero-alternative');
//   }
//}
//
//new HeroAlternative();
import AOS from "aos";
import "aos/dist/aos.css";

document.addEventListener("DOMContentLoaded", () => {
  AOS.init({ disable: "mobile" });
  if (document.querySelector(".hero-image-zoom")) {
    document.querySelectorAll(".hero-image-zoom").forEach((item) => {
      item.classList.add("zoom-hero");
    });
  }
});
